<script setup lang="ts">
import { computed, ref } from 'vue'
import VIcon from './v-icon.vue'

const props = withDefaults(
  defineProps<{
    modelValue?: string | null
    label?: string
    placeholder?: string
    property?: string
    name?: string
    id?: string
    error?: string
    v$?: any
    required?: boolean
  }>(),
  {
    placeholder: '',
    v$: {},
  },
)

const emit = defineEmits(['update:modelValue'])

const value = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
})

const visible = ref(false)
const toggle = () => {
  visible.value = !visible.value
}

const error = computed(() => props.error || props.v$[props.property || props.name]?.$errors[0]?.$message)
</script>

<template>
  <fieldset :id="id || property">
    <label :for="id" class="block cursor-pointer text-sm font-medium text-gray-700">
      <span>{{ label }}</span>
      <span v-if="required">*</span>
    </label>
    <div class="relative mt-1">
      <input
        v-model="value"
        :type="visible ? 'text' : 'password'"
        :id="id"
        :name="name || property"
        :placeholder="placeholder"
        class="block w-full rounded-md border pr-10 shadow-sm placeholder:italic focus:ring focus:ring-opacity-50"
        :class="
          error
            ? 'border-red-300 focus:border-red-300 focus:ring-red-200'
            : 'border-gray-300 focus:border-sky-300 focus:ring-sky-200'
        "
      />
      <button
        type="button"
        class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
        :aria-label="visible ? 'Hide password' : 'Show password'"
        @click="toggle"
      >
        <VIcon :name="visible ? 'EyeOff' : 'Eye'" class="h-4 w-4" />
      </button>
    </div>
    <p v-if="error" class="mt-1 text-sm text-red-500">{{ error }}</p>
  </fieldset>
</template>
